module.exports = __webpack_public_path__ + "bb7a687a979b5f2c11d768ca12c09f6a.MP3";